










import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "PayeeInfoButton",
  components: { BaseButton },
  props: {
    isLastStep: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    label: { type: String as PropType<TranslateResult | string>, default: "" },
  },
});
